import template from './contract-dropdown.html';
import controller from './contract-dropdown.controller';

let contractDropdownComponent = {
  restrict: 'E',
  bindings: {
    selectedContract: '=ngModel',
    onSelect: '&?',
    required: '<?',
    placeholder: '@?',
    disabled: '<?',
    /** When set, load contracts via /api/admin/contracts/bycustomer?customer= instead of listing all contracts. */
    filterCustomerId: '<?'
  },
  template,
  controller
};

export default contractDropdownComponent;




// WEBPACK FOOTER //
// ./client/common/directives/contract-dropdown/contract-dropdown.component.js